import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { LinkButton } from "@/components/ui/LinkButton";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: { href: string; label: string };
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "site-card mx-auto flex max-w-md flex-col items-center px-6 py-12 text-center",
        className
      )}
    >
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--site-primary)]/10 text-[var(--site-primary)]">
        <Icon size={28} aria-hidden />
      </div>
      <h3 className="font-display text-xl font-bold text-[var(--site-text)]">
        {title}
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-[var(--site-muted)]">
        {description}
      </p>
      {action && (
        <LinkButton href={action.href} variant="accent" size="md" className="mt-6">
          {action.label}
        </LinkButton>
      )}
    </div>
  );
}
